import { types, IGroupDetailed, GroupActionsType } from '../types/group'

export const initialState: IGroupDetailed = {
  isLoading: false,
  order: 0,
  name: '',
  title: '',
  description: '',
  shortTitle: '',
  created: '',
  createdBy: {
    name: '',
    id: '',
  },
  capabilities: [],
  maxFileSizeMb: 5,
  hidden: false,
}

export const group = (
  state = initialState,
  action: GroupActionsType
): IGroupDetailed => {
  switch (action.type) {
    case types.GET_GROUP_BY_ID__STARTED:
    case types.CREATE_GROUP__STARTED:
    case types.UPDATE_GROUP__STARTED:
    case types.DELETE_GROUP__STARTED:
      return { ...state, isLoading: true }
    case types.CREATE_GROUP__SUCCESS:
    case types.DELETE_GROUP__SUCCESS:
    case types.CREATE_GROUP__FAILURE:
    case types.GET_GROUP_BY_ID__FAILURE:
    case types.UPDATE_GROUP__FAILURE:
    case types.DELETE_GROUP__FAILURE:
      return { ...state, isLoading: false, message: action.message }
    case types.GET_GROUP_BY_ID__SUCCESS:
    case types.UPDATE_GROUP__SUCCESS:
      return { ...state, isLoading: false, ...action.groupData }
    case types.CLEAR_GROUP_DATA:
      return initialState
    default:
      return state
  }
}
